import { getLodop } from './LodopFuncs'
var LODOP;

(function () {
  setTimeout(function () {
    LODOP = getLodop()
  }, 900)
})()

/**
 * 打印和预览
 * data{ top：页面上边距， left：页面左边距， width：页面宽， height：页面高， list:要打印的参数， type：存在则为预览 , name：打印机序号}
 */
export function printStart(data, _this, caFun) {
  var t = data.top + 'mm'
  var l = data.left + 'mm'
  var w = (parseInt(data.width) + 2.6) + 'mm'
  var h = data.height + 'mm'
  var list = data.list
  var tp = data.type
  var printer_val = data.name
  LODOP.PRINT_INITA(t, l, 1020, 350, '')
  LODOP.SET_PRINTER_INDEXA(printer_val)
  LODOP.SET_PRINT_PAGESIZE(0, w, h, 'A4')
  for (var ii = 0; ii <= list.length; ii++) {
    if (editContent(list[ii])) {
      if (tp) {
        // 预览
        LODOP.PREVIEW()
        caFun(_this)
        return false
      } else {
        if (list.length - 1 === ii) {
          LODOP.PRINT()
          caFun(_this)
        }
      }
    }
  }
}

// 获取打印机列表
export function getPrinterList() {
  const count = LODOP.GET_PRINTER_COUNT()
  if (count === 0) return ['请没有安装打印机驱动！']
  var arr = []
  for (var i = 0; i < count; i++) {
    arr[i] = LODOP.GET_PRINTER_NAME(i)
  }
  return arr
}

// 打印内容编辑
function editContent(item) {
  if (!item || item.length === 0) return false
  LODOP.NewPage()
  var multiple = 3.78
  item.forEach(function (e) {
    var width = e.width * multiple
    var height = e.height * multiple
    var top = e.top * multiple
    var left = e.left * multiple
    if (e.type === 'TEXT') {
      var size = e.font_size * 2.8
      LODOP.ADD_PRINT_TEXT(top, left, 170, 20, e.text)
      LODOP.SET_PRINT_STYLEA(0, 'FontSize', size)
      LODOP.SET_PRINT_STYLEA(0, 'FontName', '黑体')
    } else {
      LODOP.ADD_PRINT_IMAGE(top, left, width, height, '<img border=\'0\' src=\'' + e.picture + '\' />')
      LODOP.SET_PRINT_STYLEA(0, 'Stretch', 1)
    }
  })
  return true
}
